import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServiceCard.css';

const ServiceCard = ({ icon, title, status, path, isActive }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (isActive && path) {
      navigate(path);
    }
  };

  return (
    <div
      className={`service-card ${isActive ? 'active' : 'disabled'}`}
      onClick={handleClick}
    >
      <span className="service-icon">{icon}</span>
      <p className="service-title">{title}</p>
    </div>
  );
};

export default ServiceCard;
